import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const OSETH_URL =
  'https://graphs.stakewise.io/mainnet-a/subgraphs/name/stakewise/prod?opName=osTokenApy'
const osETH = 'StakeWise Staked ETH::OSETH'

export const osethFetcher: YieldFetcher = {
  label: 'OSETH',
  fetch: async () => {
    const res = await fetch(OSETH_URL, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: JSON.stringify({
        query: 'query osTokenApy { osTokens { apy feePercent }}',
        operationName: 'osTokenApy',
      }),
    }).then((r) => r.json())
    const apr = apyToAprPercent(res.data?.osTokens?.[0]?.apy)
    return {
      [osETH]: apr,
      // token-lists unifies every osETH deployment (incl. bridged) to the bare `OSETH` group — emit there too.
      OSETH: apr,
    }
  },
}
